/*
Cet outil est utilisé pour les textes trop long a tronquer. Un bouton "Lire plus" est ajouté à la fin du texte pour l'afficher en entier.
Exemple d'implémentation : Affichage des catégories de produits Jean Hue Socoda. cf : resources/views/vendor/hegyd-products/front/contents/categories/show/show.blade.php
*/

import BaseComponent from "../../../../common/js/BaseComponent";

export default class ClampText extends BaseComponent {

    cartId: number;


    protected constructor(view: HTMLElement) {
        super(view);
    }

    init() {
        this.readMoreToggle();
    }

    readMoreToggle(){

        $('.readmore-btn').on("click",  function(event) {
            event.preventDefault();
            var max = $(this).parent().find('.text-wrapper').css('max-height');
            if(max === 'none') {
                $(this).parent().find('.text-wrapper').css('max-height', '145px');
            } else {
                $(this).parent().find('.text-wrapper').css('max-height', 'none');
            }
            var btnTextMore = $(this).data('read-more');
            var btnTextLess = $(this).data('read-less');
            $(this).html($(this).html() == btnTextMore ? btnTextLess : btnTextMore);
        });
    }
}
